import {
  Directive,
  Input,
  ElementRef,
  OnChanges
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Directive({
  selector: '[b64ToCanvas]'
})

export class B64ToCanvas implements OnChanges {
  canvas: any;
  context: any;
  lastWidth: number;
  lastHeight: number;

  @Input() inputs: any = {};

  constructor(
    private _eref: ElementRef
  ) {
    this.canvas = this._eref.nativeElement;
    this.context = this.canvas.getContext('2d');
  }

  draw(image) {
    this.context.drawImage(image, 0, 0);
  }

  loadB64Image$(uri): Observable<any> {
    let img = new Image();
    let loader$ = new Subject();

    img.src = 'data:image/png;base64,' + uri;
    img.onload = () => {
      loader$.next(img);
      loader$.complete();
    };
    img.onerror = (err) => console.error(err);

    return loader$;
  }

  ngOnChanges() {
    if (this.lastWidth && this.lastHeight) {
      this.context.clearRect(0, 0, this.lastWidth, this.lastHeight);
    }

    if (this.inputs && this.inputs.uri) {
      this.loadB64Image$(this.inputs.uri)
        .take(1)
        .subscribe(image => {
          this.canvas.width = this.lastWidth = image.naturalWidth;
          this.canvas.height = this.lastHeight = image.naturalHeight;
          this.draw(image);
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/b64-to-canvas/b64-to-canvas.directive.ts